import React from "react";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import Button from "react-bootstrap/Button";
import AxiosConfig from "axiosConfig";
import { Player } from "video-react";
import TextTheme from "components/General/Text/TextTheme";
import ProjectBanner from "components/Project/ProjectBanner";
import * as CONSTANT from "constants/text";
import Image from "react-bootstrap/Image";

class ProjectInvitation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      invitationMessage: "",
      video: "",
      projectCategory: "",
      projectTags: "",
      projectMission: "",
      projectGoal: "",
      errorMessage: "",
      projectBanner: "",
      projectSlug: this.props.match.params.slug,
      projectName: "",
    };
  }
  buttonHandler() {
    this.props.history.push({
      pathname: "/projects/" + this.state.projectSlug,
      state: {
        isInvite: true,
        challengeSlug: this.props.location.state.challengeSlug,
        adventureId: this.props.location.state.adventureId,
        adventureSlug: this.props.location.state.adventureSlug,
        email: this.props.location.state.email,
        invitationId: this.props.location.state.invitationId,
      },
    });
  }

  componentDidMount() {
    this.getInvitationDetails();
    this.getProjectBanner();
  }

  getProjectBanner() {
    const projectSlug = this.props.match.params.slug;
    AxiosConfig.get(`/impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectBanner: res.data["banner"],
        });
      })
      .catch();
  }

  getInvitationDetails() {
    const { slug, inviterEmail } = this.props.match.params;
    const invitationId = this.props.location.state.invitationId;

    AxiosConfig.get(`/impactprojects/project_invitation_details/`, {
      params: {
        slug: slug,
        inviter_user_email: inviterEmail,
        invitationId: invitationId,
      },
    })
      .then((res) => {
        this.setState({
          userName: res.data["invitee_user_name"],
          invitationMessage: res.data.invitation_message,
          video: res.data.video,
          projectCategory: res.data.project.category,
          projectTags: res.data.project.tags,
          projectMission: res.data.project.mission,
          projectGoal: res.data.project.goal,
          projectName: res.data.project.name,
        });
      })
      .catch();
  }

  showAlertMsg() {
    if (!this.state.error_message !== CONSTANT.BACKEND_SUCCESS) {
      return (
        <TextTheme
          message={this.state.errorMessage}
          className="text_medium text_red"
        />
      );
    }
  }

  render() {
    const url = this.state.video;
    return (
      <div className="header_main">
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo vertical={true} project={this.state.projectSlug} />
          </div>

          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo project={this.state.projectSlug} />
            </div>
            <div className="mt-15 page_details_content_main">
              <h2 className="mb-15 textHeader d-inline-block">
                PROJECT INVITATION
              </h2>

              <h4 className="mt-15 d-inline-block w-100 text_black">
                DEAR {this.state.userName.toUpperCase()},
              </h4>
              <TextTheme
                className="mt-15 mb-15 text_medium text_black d-inline-block"
                message={
                  "I just started a new charity project, " +
                  this.state.projectName +
                  ". Please check it out and I hope you can join me! Together, we can make a BIG difference in the world."
                }
              />
              <div className="mt-15 mb-15 d-inline-block w-100 project-invite-video">
                {url != null ? (
                  url.match(/\.(jpeg|jpg|gif|png|JPG|JPEG|PNG)$/) != null ? (
                    <Image src={url} className="w-100" />
                  ) : (
                    <Player playsInline src={url} />
                  )
                ) : null}
              </div>
              <div className="mt-15">
                <h2 className="textHeader">Project Mission</h2>
                {this.state.projectMission}
              </div>

              <div className="mt-15">
                <h2 className="textHeader">Project Goal</h2>
                {this.state.projectGoal}
              </div>
              <div className="JoinBtn">
                <Button
                  className="startButton"
                  onClick={this.buttonHandler.bind(this)}
                  variant="success"
                  size="lg"
                >
                  JOIN PROJECT
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectInvitation;
